import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getOrderID, saveOrder } from "../store/slices/Project/ProjectSlice";
import {
  hdfcPayment,
  inititatePayment,
  paymentCompletion,
  paymentModalAction,
  updateConfig,
} from "../store/slices/Payment/checkoutSlice";
import { toast } from "react-toastify";

const useStudioPayment = () => {
  const { allPlans, stepOneFormData, stepTwoFormData } = useSelector(
    (state) => state.project.addProjects
  );
  const { REACT_APP_APIURL, RAZORPAY_KEY_ID } = process.env;
  const { userProfileData } = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /****************************************************************
   * THIS FUNCTION CHECKS REQUEST TO SELECT PLAN IS VALID NOT NOT *
   ****************************************************************/

  const isItValidRequest = () => {
    if (stepOneFormData == "" || stepTwoFormData == "") {
      navigate("/dashboard");
    }
  };

  const handleInitPayment = (data) => {
    dispatch(
      hdfcPayment({
        redirect_url: `${REACT_APP_APIURL}ccavenue/verify-order`,
        cancel_url: `${REACT_APP_APIURL}ccavenue/verify-order`,
        plan_id: data.id,
      })
    )
      .unwrap()
      .then((res) => {});
  };
  function loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => reject(new Error("Script load error"));
      document.head.appendChild(script);
    });
  }
  async function handleRazorPaySubmit(values, result, type) {
    if (!result?.order_id) {
      toast.error("Something went wrong");
      // setEasyPayStates((state) => ({ ...state, isPaying: false }));
      return;
    }

    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      toast.error("Razorpay SDK failed to load. Are you online?");
      // setEasyPayStates((state) => ({ ...state, isPaying: false }));
      return;
    }
    const options = {
      key: RAZORPAY_KEY_ID,
      amount: result?.purchased_amount,
      currency: values?.plans_prices?.[0]?.countries?.currency_code,
      name: "Family Photos",
      description: "Test Transaction",
      order_id: result?.order_id,
      handler: async function (response) {
        if (response) {
          const body = {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
            type: type,
            // razor_status: "success",
            // plan_id: easyPayStates?.packageDetail?.id ?? null,
            // offer_amount: easyPayStates?.offerAmount ?? null,
            // payment_id: "",
            // offer_code: easyPayStates?.offerCode,
            // total_amount: "50000",
          };
          if (!response?.razorpay_payment_id) {
            confirmPaymentAfterSuccess(body, "error");
            // setMessage(error.message);
          } else if (response?.razorpay_payment_id) {
            // setMessage("Payment Status: "  + "🎉");
            // setIsPaymentSuccess(true);
            confirmPaymentAfterSuccess(body, "success", type);
          } else {
            toast.error("An unexpected error occurred.");
          }
          // verifyRazorPay(body)
          //   .then((resp) => {
          //     if (resp?.data?.status_code === 200) {
          //       router.push("/payment-receipt/success");
          //     } else {
          //       // toast.error("Payment error");
          //       router.push("/payment-receipt/failure");
          //     }
          //   })
          //   .finally(() => {
          //     setEasyPayStates((state) => ({ ...state, isPaying: false }));
          //   });
        }
      },
      modal: {
        ondismiss: function () {
          // setEasyPayStates((state) => ({ ...state, isPaying: false }));
          toast.error("Payment failed");
        },
      },
      theme: { color: "#950053" },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }
  const handleInitiatePaymentRazor = async (item, details, type) => {
    // setSelectedId(item?.id);
    let data = {
      plan_id: item?.id ?? "",
      country_id: item?.plans_prices?.[0]?.countries?.id ?? "",
      currency: item?.plans_prices?.[0]?.countries?.currency_code ?? "",
      type: type,
      ...details,
    };
    if (item?.clientID !== undefined) {
      data.client_id = item?.clientID;
    }

    if (item?.projectID !== undefined) {
      data.project_id = item?.projectID;
    }
    // dispatch(inititatePayment(data));
    const resultAction = await dispatch(inititatePayment(data));
    if (inititatePayment.fulfilled.match(resultAction)) {
      handleRazorPaySubmit(item, resultAction?.payload?.data?.result, type);
    }
  };
  const confirmPaymentAfterSuccess = async (body, type, paymentType) => {
    const resultAction = await dispatch(paymentCompletion(body));
    if (
      paymentCompletion.fulfilled.match(resultAction) &&
      resultAction?.payload?.data?.success
    ) {
      // dispatch(
      //   updateActivePlanAfterPusrchase(
      //     resultAction.payload.data?.result?.activated_plan
      //   )
      // );
      if (type == "error") {
        closePaymentModal();
        toast.error("Payment Failed");
      }
      if (type == "success") {
        if (paymentType === "Addon") {
          closePaymentModal();
          dispatch(updateConfig((state) => (state.thankYouPopup = true)));
          setTimeout(() => {
            dispatch(updateConfig((state) => (state.thankYouPopup = false)));
          }, 3000);
        } else {
          // setTimeout(() => {
          //   // closePaymentModal()
          //   window.location = "/studio/get-started";
          //   // navigate("/dashboard");
          // }, 1000);
          // if(userProfileData?.is_package){
            navigate("/dashboard");
          // }else{
          //   window.location = "/studio/get-started";
          // }
        }
      }
    } else {
      closePaymentModal();
      toast.error(resultAction?.payload?.data?.message);
    }
  };
  const closePaymentModal = () => {
    dispatch(paymentModalAction(false));
  };
  const paymentCompleted = (Data) => {};

  /**********************************************************
   * THIS FUNCTION CALLS WHEN THE USER COMPLETE THE PAYMENT.
   * AFTER THE PAYMENT COMPLETION FINALL CALL WILL BE MADE WITH PAYMENT ID WHICH CAN BE COLLETED FROM PAYMENT GATEWAY AND ORDER ID *
   **********************************************************/

  const handleSaveOrder = (paymentID, order_id) => {
    let formData = {
      id: paymentID,
      order_id: order_id,
    };

    dispatch(saveOrder(formData))
      .unwrap()
      .then((result) => {
        const { success, message } = result.data;
        if (success === true) {
          navigate("/dashboard");
        } else {
          alert(message);
        }
      });
  };

  return { isItValidRequest, handleInitPayment, handleInitiatePaymentRazor };
};

export default useStudioPayment;
